import React, { ReactNode, createContext } from 'react';
import { useNamedSettingsMenu } from './table-named-settings-hook';

type ContextType = ReturnType<typeof useNamedSettingsMenu>;

export const ParsedTableNamedSettingsContext = createContext<ContextType>(
  {} as ContextType
);

export const ParsedTableNamedSettingsProvider = ({
  children,
  tableId,
}: {
  children: ReactNode;
  tableId: string;
}) => {
  const props = useNamedSettingsMenu(tableId);
  return (
    <ParsedTableNamedSettingsContext.Provider value={{ ...props }}>
      {children}
    </ParsedTableNamedSettingsContext.Provider>
  );
};
